
<div id="app">
  <LangNavbar class="lang-nav-bar--right-top" v-if="hasLangNavBar" />
  <router-view />
</div>
